module.exports = __webpack_public_path__ + "static/media/icn_artists_60x60.8404f918.svg";